import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';

/**
 * Card header shared by Container and ContainerBlue: centred heading over the
 * short accent rule. Renders nothing when neither title nor label is given.
 * @param {string} [title] - Translation key, resolved through the translator
 * @param {string} [titleFallback] - Text shown when title has no matching translation
 * @param {string|number} [label] - Literal text, appended after the title when both are given
 * @param {React.ReactNode} [action] - Optional control pinned to the right side of the header
 */
const CardHead = ({ title, titleFallback, label, action }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();

  if (!title && !label) return null;

  const translatedTitle = title ? tempedgeTranslator(title, undefined, titleFallback) : null;

  return (
    <div className="te-card-head">
      <h2 className="te-card-title">
        {translatedTitle}
        {translatedTitle && label && ' '}
        {label}
      </h2>
      <span className="te-card-rule" />
      {action && <div className="te-card-head-action">{action}</div>}
    </div>
  );
};

export default CardHead;
